
export type Calendar1MobileProps = {
    month: number,
    year?: number,
    mode: string
};

export const Calendar1Mobile = (props: Calendar1MobileProps) => {
    const { month } = props;
    const { year } = props;
    const { mode } = props;
    return (
        <>
            {mode === 'calendar1' && 
                <>
                    <tr>
                        <th colSpan={3} rowSpan={1} style={{ minWidth: '60px', backgroundColor: '#e6b800', verticalAlign: 'middle'}}>{year}年{month}月</th>
                        {[...Array(24)].map((x, i) =>
                            <th rowSpan={2} style={{ minWidth: '60px', backgroundColor: "#e6b800"}}>{i.toString().padStart(2, '0')} h</th>
                        )}
                    </tr>
                    <tr>
                        <th style={{ minWidth: '100px', backgroundColor: '#e6b800'}}>日合計</th>
                        <th style={{ minWidth: '60px', backgroundColor: '#e6b800'}}>日</th>
                        <th style={{ minWidth: '60px', backgroundColor: '#e6b800'}}>曜日</th>
                    </tr>
                </>
            }

            {mode === 'calendar2' && 
                <>
                    <tr>
                        <th colSpan={3} rowSpan={1} style={{ minWidth: '60px', backgroundColor: '#e6b800'}}>{year}年{month}月</th>
                        {[...Array(24)].map((x, i) =>
                            <th colSpan={2} style={{ minWidth: '60px', backgroundColor: "#e6b800"}}>{i.toString().padStart(2, '0')} h</th>
                        )}
                    </tr>
                    <tr>
                        <th style={{ minWidth: '100px', backgroundColor: '#e6b800',}}>日最大</th>
                        <th style={{ minWidth: '60px', backgroundColor: '#e6b800'}}>日</th>
                        <th style={{ minWidth: '60px', backgroundColor: '#e6b800'}}>曜日</th>
                        {[...Array(24)].map((x, i) =>
                            <>
                                <th style={{ minWidth: '60px', backgroundColor: '#e6b800'}}>00</th>
                                <th style={{ minWidth: '60px', backgroundColor: '#e6b800'}}>30</th>
                            </>
                        )}
                    </tr>
                </>
            }
            {mode === 'calendar3' && 
                <>
                    <tr>
                        <th colSpan={3} rowSpan={1} style={{ minWidth: '60px', backgroundColor: '#e6b800', verticalAlign: 'middle'}}>{year}年{month}月</th>
                        {[...Array(24)].map((x, i) =>
                            <th rowSpan={2} style={{ minWidth: '60px', backgroundColor: "#e6b800"}}>{i.toString().padStart(2, '0')} h</th>
                        )}
                    </tr>
                    <tr>
                        <th style={{ minWidth: '100px', backgroundColor: '#e6b800'}}>日合計</th>
                        <th style={{ minWidth: '60px', backgroundColor: '#e6b800'}}>日</th>
                        <th style={{ minWidth: '60px', backgroundColor: '#e6b800'}}>曜日</th>
                    </tr>
                </>
            }
        </>
    );
};

export default Calendar1Mobile;
